import { LabelQuestionConfig, LabelResponseState } from '@gripp/shared-logic';
import { CommonLabel } from '../../../components/commonLabel';
import {
  RoutineQuestionExecutionForm,
  RoutineQuestionExecutionFormProps,
} from '../types';

export const LabelQuestionExecutionForm: RoutineQuestionExecutionForm<
  LabelQuestionConfig,
  LabelResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    LabelQuestionConfig,
    LabelResponseState
  >
) => {
  const fieldPrefix = `responses.${props.responseIndex}`;
  const fieldName = `${fieldPrefix}.labels`;

  return (
    <>
      {props?.workspaceAsset?.id && (
        <CommonLabel
          workspaceId={props.workspaceAsset.workspace.id}
          fieldName={fieldName}
        />
      )}
    </>
  );
};
